import SuitcaseColor from './SuitcaseColour.svg';
import SuitcaseDark from './SuitcaseDark.svg';
import SuitcaseLight from './SuitcaseLight.svg';
export const suitcase = { color: SuitcaseColor, dark: SuitcaseDark, light: SuitcaseLight };
//# sourceMappingURL=index.js.map